"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfilePhotoStatus = void 0;
var ProfilePhotoStatus;
(function (ProfilePhotoStatus) {
    ProfilePhotoStatus[ProfilePhotoStatus["Pending"] = 0] = "Pending";
    ProfilePhotoStatus[ProfilePhotoStatus["Accepted"] = 1] = "Accepted";
    ProfilePhotoStatus[ProfilePhotoStatus["Declined"] = 2] = "Declined";
})(ProfilePhotoStatus || (exports.ProfilePhotoStatus = ProfilePhotoStatus = {}));
//# sourceMappingURL=ProfilePhotoStatus.js.map